// extracted by mini-css-extract-plugin
module.exports = {"textarea":"patient_textarea__2SaE-"};